__turbopack_context__.v({
  "allergensBody": "Nutrition-module-scss-module__Jp16tG__allergensBody",
  "allergensHeading": "Nutrition-module-scss-module__Jp16tG__allergensHeading",
  "fade-in": "Nutrition-module-scss-module__Jp16tG__fade-in",
  "icon": "Nutrition-module-scss-module__Jp16tG__icon",
  "indent": "Nutrition-module-scss-module__Jp16tG__indent",
  "inner": "Nutrition-module-scss-module__Jp16tG__inner",
  "line": "Nutrition-module-scss-module__Jp16tG__line",
  "pdv": "Nutrition-module-scss-module__Jp16tG__pdv",
  "root": "Nutrition-module-scss-module__Jp16tG__root",
  "separator": "Nutrition-module-scss-module__Jp16tG__separator",
  "servings": "Nutrition-module-scss-module__Jp16tG__servings",
  "theme--makers-reserve": "Nutrition-module-scss-module__Jp16tG__theme--makers-reserve",
});
